import "./Profile.html";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { ProfileComponentController } from "./ProfileComponentController";

import "./AddToHomescreen/ProfileAddToHomescreenComponent";
import "./Localization/ProfileLocalizationComponent";
import "./NotificationSettings/ProfileNotificationSettingsComponent";
import "./Partners/ProfilePartnersComponent";
import "./Password/ProfilePasswordComponent";
import "./Sites/ProfileSitesComponent";
import "./UserInformation/ProfileUserInformationComponent";

export class ProfileComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = ProfileComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/Profile/Profile.html";
    }
}
